import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from "@angular/router";
import { ReactiveFormsModule } from '@angular/forms';

import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';

import { LunaCoreModule } from "../core/core.module";
import { LunaCommonModule } from "../common/common.module";
import { AccordionModule } from "../common/components/accordion/accordion.module";
import { HelpLibraryHomeComponent } from './components/help-library-home/help-library-home.component';
import { HelpLibraryService } from "./services/help-library.service";
import { HelpLibraryNavigationComponent } from './components/help-library-navigation/help-library-navigation.component';
import { HelpLibraryEditorComponent } from './components/help-library-editor/help-library-editor.component';
import { HelpLibraryViewerComponent } from './components/help-library-viewer/help-library-viewer.component';
import { HelpLibraryPreviewComponent } from './components/help-library-preview/help-library-preview.component';
import { HelpNavigationItemComponent } from './components/help-library-navigation/help-navigation-item/help-navigation-item.component';
import { HelpLibraryViewResolver } from "./resolvers/help-library-view.resolver";
import { HelpLibraryEditorResolver } from "./resolvers/help-library-editor.resolver";

@NgModule({
    providers: [
        HelpLibraryService,
        HelpLibraryViewResolver,
        HelpLibraryEditorResolver
    ],
    declarations: [
        HelpLibraryHomeComponent,
        HelpLibraryNavigationComponent,
        HelpLibraryEditorComponent,
        HelpLibraryViewerComponent,
        HelpLibraryPreviewComponent,
        HelpNavigationItemComponent],
    imports: [
        RouterModule,
        CommonModule,
        ReactiveFormsModule,
        LunaCoreModule,
        LunaCommonModule,
        AccordionModule,
        FroalaEditorModule,
        FroalaViewModule
    ],
    exports: [
        HelpLibraryNavigationComponent
    ]
})
export class HelpLibraryModule { }
